import { render } from "./Element.vue?vue&type=template&id=001e54d3&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"

import "./Element.vue?vue&type=style&index=0&id=001e54d3&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/agenda/v3/prod/frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001e54d3"]])

export default __exports__